module.exports = __webpack_public_path__ + "static/70e99bed380f39d713ee531689a3a162ab612ef43f8c5d913d770777f9ca51a3-aba1413aaf26b1ee09c0c16571d39864.jpeg";